import React, { Component } from 'react';
import { Button, Modal, Form, Card, ListGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { filterTasks, addTasksToProject, resetTasksToProject } from '../../store/actions/projects/tasksActions';
import { saveTasksToProject } from '../../store/actions/projects/projectTasksActions';
import { toggleDialogBox } from '../../store/actions/commonActions';
import '../../css/projects.css';

class AddTasksToProject extends Component {

  getTasks = () => {
    const projectTasks = this.props.projects.projectTasks;
    const selectedTask = this.props.tasks.tasksToProject;
    const tasks = this.props.tasks.tasks;
    let tasksList = '';
    let projectTaskIds = [];

    if (projectTasks) {
      if (projectTasks.length > 0) {
        projectTasks.forEach(projectTask => {
          projectTaskIds.push(projectTask.task_id);
        });
      }
    }
    
    if (tasks) {
      tasksList = tasks.length ? (
        tasks.filter(data => {
          const filterKeyword = this.props.tasks.taskSearchKeyword;
          if (!projectTaskIds.includes(data.id)
              && (!filterKeyword 
                  || data.name.toLowerCase().includes(filterKeyword.toLowerCase())
              )) {
                
              return data;
          }

          return null;
        }).map((task, key) => {
          let isSelected = false;
          if (selectedTask.includes(task.id.toString())) {
            isSelected = true;
          }
          return  (
            <ListGroup.Item key={key}>
              <Form.Check type="checkbox" label={task.name} checked={isSelected} id={task.id} value={task.id} onClick={(e) => {
                const taskId = e.target.value;
                
                let actionItem = '';
                if (e.target.checked) {
                  actionItem = "add";
                }
                else  {
                  actionItem = "remove";
                }

                this.props.addTasksToProject(taskId, actionItem);
              }}/> 
            </ListGroup.Item>
         )
       })
      ) : (
        <div className="mx-5">
          Loading...
        </div>
      )
    }
    else {
      tasksList = <tr><td colSpan={2}><p className="text-danger">No results found.</p></td></tr>
    }

    return tasksList;
  }

  filterTasks = () => {
    return (
      <div id="t3-tasks-filter">
        <Form.Control size="sm" type="text" placeholder="Search tasks" onChange={(e) => {
          const value = e.target.value;
          this.props.filterTasks(value);
        }} />
        <div className="d-flex flex-row-reverse">
          <Link to="#" className="py-1" onClick={(e) => {
            e.preventDefault();
            document.querySelectorAll(".list-group input[type='checkbox']")
              .forEach(checkbox => checkbox.click());
          }}>
            Check all shown
          </Link>
        </div>
      </div>
    )
  }

  handleSubmit = (e) => {
    e.preventDefault();
  }

  render() {
    return (
      <Modal id="t3-add-tasks-modal" show={this.props.common.toggleDialog} onHide={() => {
          this.props.toggleDialogBox(false);
          
        }} backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>Add Task to Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { this.filterTasks() }
          <Card>
            <ListGroup variant="flush">
              { this.getTasks() }
            </ListGroup>
          </Card>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              this.props.resetTasksToProject();
              this.props.toggleDialogBox(false);
            }}>
                Cancel
            </Button>
            <Button variant="primary" type="button" onClick={() => {
              this.props.saveTasksToProject();
            }}>
                Add
            </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
  projects: state.projects, 
  tasks: state.tasks 
})

const mapDispatchToProps = (dispatch) => {
  return {
    filterTasks: (...args) => dispatch(filterTasks(...args)),
    addTasksToProject: (...args) => dispatch(addTasksToProject(...args)), 
    resetTasksToProject: () => dispatch(resetTasksToProject()), 
    saveTasksToProject: () => dispatch(saveTasksToProject()), 
    toggleDialogBox: (...args) => dispatch(toggleDialogBox(...args))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddTasksToProject)
